import LegalPage, { type LegalSection } from "@/components/public/LegalPage";

const SECTIONS: LegalSection[] = [
  { id: "controller" },
  { id: "dpo" },
  { id: "purposes" },
  { id: "categories" },
  { id: "recipients" },
  { id: "transfers" },
  { id: "retention" },
  { id: "rights" },
  { id: "complaint" },
  { id: "cookies" },
  { id: "updates" },
];

export default function PrivacyPolicy() {
  return (
    <LegalPage
      namespace="legal.privacy"
      sections={SECTIONS}
      lastUpdated="2026-05-13"
      contactEmail="dpo@delapresse.fr"
    />
  );
}
